export default "Diagnostic CEE Industriel — Primes IND-UT/IND-BA | Solution Éco France";
